import React, { useState, useEffect } from "react";
import { Button, Flex, FlexItem, RichText } from "@chatui/core";
import { getInitInfo } from "../services/yoobot";
import "../pages/customerService.css";
import "./questionList.css";
import { renderText } from '../utils/util'

// 渲染问题推荐
const RenderRemind = (props) => {
	const { list, needRef, setPageIndex, questionClick, title, guide, content } = props;
	const [qes_list, setQes_list] = useState([]);
	useEffect(() => {
		setQes_list(list || []);
	}, [list]);
	// 点击刷新问题列表
	const refreshQes = () => {
		setPageIndex((page) => {
			const newPage = page + 1;
			getInitInfo({ page: newPage }).then((res) => {
				setQes_list(res.data.question);
			});
			return newPage;
		});
	};
	return (
		<div>
			<Flex wrap="wrap" style={{ maxWidth: "320px", flexDirection: 'column' }}>
				<FlexItem key={-1} flex="1 0 auto" className="flex-wrap">
					<div className="qus-item">
						<div
							style={{
								padding: "5px 0px",
								paddingBottom: "10px",
								paddingLeft: !title ? '25px' : '0px',
								position: "relative"
							}}
						>
							{!title && <img
								style={{ width: '20px', verticalAlign: 'text-bottom', marginRight: '5px', position: 'absolute', left: 0 }}
								src={require('../asset/imgs/icon_logo.png').default}
								alt='title'
							></img>}
							<span style={{ marginLeft: "5px", fontSize: '16px', marginRight: '20px' }}>
								{title ? <RichText style={{ display: 'inline-block' }} content={title}></RichText> : renderText('ques_recommend')}

							</span>
							{needRef && (
								<img
									onClick={refreshQes}
									style={{ position: "absolute", right: "5px", fontSize: "20px", top: '50%', marginTop: '-13px', color: "#CCCCCC", width: '20px' }}
									src={require('../asset/imgs/icon_g2.svg').default}
									alt='needRef'
								></img>
							)}
						</div>
					</div>
				</FlexItem>
				{qes_list && qes_list.map((item, index) => {
					return (
						<FlexItem key={index} flex="1 0 auto" className="flex-wrap">
							<div
								className="qus-item"
							>
								<div style={{ width: '100%' }}>
									<Button
										style={{
											color: "var(--gray-1)",
											fontSize: "14px",
											padding: "5px 0",
											wordBreak: 'break-word',
											fontWeight: '400'
										}}
										variant="text"
										onClick={() => {
											questionClick(item.name, item.question_id, 0, guide, content);
										}}
									>
										{item.name}
									</Button>
								</div>
							</div>
						</FlexItem>
					);
				})}
				{(!qes_list || qes_list.length === 0) && <FlexItem flex="1 0 auto" className="flex-wrap">
					<div
						style={{
							borderBottom: "1px solid #F3F3F3",
							padding: "5px 0",
						}}
						className="qus-item"
					>
						<div style={{ width: '100%' }}>
							<Button
								style={{
									color: "var(--gray-1)",
									fontSize: "14px",
									padding: "5px",
									wordBreak: 'break-word'
								}}
								variant="text"
							>
								{renderText('很抱歉，暂时没有内容推荐')}
							</Button>
						</div>
					</div>
				</FlexItem>}
			</Flex>
		</div>
	);
};

export default RenderRemind;
